var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"no-data"},[_c('i',{staticClass:"iconfont icon-kafei"}),_c('p',[_vm._v("这里空空如也")])])
}]

export { render, staticRenderFns }